<template>
    <div
        v-if="active"
        class="appear filebrowser"
    >
        <div class="filebrowser-inner">
            <ul
                class="pagination pagination-sm mb-0"
                style="margin-left: 3rem; margin-top: 1rem;"
            >
                <span
                    v-for="(group, index) in browserPages"
                    :key="index"
                >
                    <li
                        v-if="index > 0 && index <= browserPages.length"
                        class="page-item disabled"
                    >
                        <a>...</a>
                    </li>
                    <li
                        v-for="page in group"
                        :key="page.number"
                        class="page-item"
                        :class="{'active': page.number == browserPage}"
                    >
                        <span
                            class="page-link"
                            :href="page.url"
                            @click.prevent="loadPage(page.number, page.url)"
                        >
                            {{ page.number }}
                        </span>
                    </li>
                </span>
            </ul>
            <div class="col mr-3 mb-3 ml-3 pb-3 pl-3 pr-3 filebrowser-content">
                <div
                    v-if="browserImages.length == 0"
                    class="empty-message"
                >
                    Нет загруженных изображений для этого сайта
                </div>
                <div
                    v-for="(im, index) in browserImages"
                    :key="index"
                >
                    <template v-if="index == 0 && browserImages">
                        <div class="filebrowser-date text-light">
                            {{ im.date }}
                        </div>
                    </template>
                    <template v-else-if="browserImages && index > 0">
                        <div
                            v-if="browserImages[index-1] && im.date !== browserImages[index-1].date"
                            class="filebrowser-date text-light"
                        >
                            {{ im.date }}
                        </div>
                    </template>
                    <div 
                        class="fb-image" 
                        :class="{'selected': browserChosen && browserChosen.id === im.id}"
                        :style="{backgroundImage: 'url('+im.url+')',}"
                        @click.stop.prevent="browserSelect(im.id, im.url)" 
                    >
                        <span
                            v-if="browserChosen && browserChosen.id === im.id"
                            style="left: 0; right: 0; top: 0; bottom: 0; background-color: rgba(255,255,255,0.6); position: absolute;"
                        >
                            <i
                                class="fa fa-check"
                                style="font-size: 50px; position: absolute; top: 50%; margin-top: -25px; margin-left: -25px;"
                            />
                        </span>
                    </div>
                </div>
                <div style="height: 50px; clear: both;" />
            </div>
            <div
                class="row"
                style="position: absolute; width: auto; bottom: 10px; left: 2rem; right: 2rem;"
            >
                <div class="col col-sm-6 text-left">
                    <button
                        class="btn btn-primary ml-3 mb-1" 
                        :class="{disabled: !browserChosen}"
                        @click="browserConfirm"
                    >
                        <span class="fa fa-check" /> Вставить
                    </button>
                </div>
                <div class="col col-sm-6 text-right">
                    <button
                        class="btn btn-secondary mr-3 mb-1"
                        @click="closeBrowser"
                    >
                        <span class="fa fa-times" /> Закрыть
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Filebrowser',
        props: {
            'active': {
                'type': Boolean,
                'default': false,
            }
        },
        data: function(){
            return {
                browserPage: null,
                browserImages: [],
                browserPages: [],
                browserChosen: null,
            }
        },
        watch: {
            active: function() {
                if (this.active){
                    this.loadPage();
                }
            }
        },
        methods: {
            loadPage: function(number=null, url=null) {
                let editor = document.getElementById('ckeditor-container');
                editor.style.display = 'none';
                if (!url) {
                    url = '/uploads/'+this.$root.siteId+'/';
                }
                if (!number) {
                    number = 1;
                }
                let ap = this;
                $.get( url, function(data) {
                    ap.browserImages = data.uploads;
                    ap.browserPages = data.pagination;
                    ap.browserPage = number;
                })
            },
            closeBrowser: function() {
                let editor = document.getElementById('ckeditor-container');
                editor.style.display = 'block';
                this.$emit('close');
            },
            browserSelect: function(id, url) {
                if (this.browserChosen && id == this.browserChosen.id) {
                    this.browserChosen = null;
                } else {
                    this.browserChosen = {'id': id, 'url': url};
                }
            },
            browserConfirm: function() {
                if (this.browserChosen) {
                    this.$emit('imagechosen', this.browserChosen.id, this.browserChosen.url); 
                    this.browserChosen = null;
                    this.browserImages = [];
                }
            },
        }
    }
</script>

